module.exports = __webpack_public_path__ + "static/media/nextButton.bb3081b3.svg";